import React from 'react';
import { useCheckout } from './CheckoutContext';
export function OfferBox() {
  const {
    openUpsell
  } = useCheckout();
  return <section className="px-4 py-7 sm:py-9 border-t border-brand-gold/10" data-id="element-132">
      <div className="max-w-3xl mx-auto" data-id="element-133">
        <div className="border border-brand-gold bg-dark-card rounded-lg p-5 sm:p-7 shadow-2xl" data-id="element-134">
          <h3 className="font-serif text-xl sm:text-2xl font-bold text-center mb-4" data-id="element-135">
            Acceso completo a Realmanifestación
          </h3>

          <div className="text-center mb-4" data-id="element-136">
            <p className="text-brand-gray line-through text-sm sm:text-base mb-0" data-id="element-137">
              Precio normal: $50.000 ARS
            </p>
            <p className="text-brand-gold text-3xl sm:text-4xl font-bold leading-tight" data-id="element-138">
              HOY $19.990 ARS
            </p>
          </div>

          <div className="grid grid-cols-2 gap-x-4 gap-y-1.5 max-w-md mx-auto mb-5" data-id="element-139">
            {['Descarga inmediata', 'Acceso permanente', 'Garantía 7 días', 'Actualizaciones futuras'].map((item, i) => <div key={i} className="flex items-center gap-2 text-xs sm:text-sm" data-id="element-140">
                <span className="text-brand-gold" data-id="element-141">✓</span>
                <span data-id="element-142">{item}</span>
              </div>)}
          </div>

          <button onClick={openUpsell} className="w-full bg-brand-gold text-brand-black px-6 py-3.5 rounded text-base sm:text-lg font-bold hover:opacity-90 transition-all hover:scale-[1.02]" data-id="element-143">
            QUIERO ACCESO AHORA
          </button>
        </div>
      </div>
    </section>;
}